import { Component, OnInit, TemplateRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { GenericServiceService } from '../services/generic-service.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { RestaurantServiceService } from '../restaurant/restaurant-service.service';

@Component({
  selector: 'app-meals',
  templateUrl: './meals.component.html',
  styleUrls: ['./meals.component.scss']
})
export class MealsComponent implements OnInit {
  private resID: number;
  private menuID: number;
  mealList: any = [];
  msg: string;
  modalRef: BsModalRef;
  message: string;
  popular_Id = 0;
  popular_load = false;
  p=1;


  constructor(
    private mealService: GenericServiceService,
    private restaurantServices: RestaurantServiceService,
    private router: Router,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private modalService: BsModalService
  ) { }

  openMealModal() {

  }

  ngOnInit() {
    this.resID = Number(this.route.snapshot.paramMap.get('restId'));
    this.menuID = Number(this.route.snapshot.paramMap.get('menuId'));

    console.log('resID', this.resID, 'menuID', this.menuID);
    this.getRestaturantMenus();
  }
  gotoAddMeals() {
    this.router.navigateByUrl('/newMeal/' + this.resID + '/' + this.menuID);

  }
  getRestaturantMenus() {
    this.mealService.GETMeals(this.menuID).subscribe(Response => {
     this.mealList = Response;
     for (const i in this.mealList) {
      if (this.mealList[i].IsFeatured) {
        this.msg = 'Popular';
      } else {
       this.msg = 'Non Popular';
      }
     }

    //  this.spin = true;
     console.log('List OF Meals', this.mealList);
    });
  }
  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, {class: 'modal-sm'});
  }

  confirm(id): void {
    // this.message = 'Confirmed!';
    this.restaurantServices.DeleteMeal(id).subscribe(Response => {
      // this.toastr.success('Meal deleted...');
      console.log('Response Delete API', Response);
      this.getRestaturantMenus();
    });
    this.modalRef.hide();
  }

  decline(): void {
    // this.message = 'Declined!';
    this.modalRef.hide();
  }

  changeStatus(id) {
    this.popular_Id = id;
    this.popular_load = true;
    this.restaurantServices.GETIsFeatuedStatus(id).subscribe(Response => {
      console.log('Featured status', Response);
      // this.spin = true;

    this.popular_load = false;
    this.popular_Id = 0;
      this.getRestaturantMenus();
    });
  }

  UpdateMealNavigation(id) {
    this.router.navigateByUrl('/updateMeal/'  + this.resID + '/' + this.menuID + '/' + id);
  }

  gotoMealDetail(id) {
    this.router.navigateByUrl('/mealDetail/' + this.resID + '/' + this.menuID + '/' + id);
  }

}
